import type { RouteRecordRaw } from 'vue-router'

// 登录 / 注册相关
export const loginRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/Login/index.vue'),
    meta: { backMode: 'exit' },
  },
  {
    path: '/bind-phone',
    name: 'bind-phone',
    component: () => import('@/pages/Login/BindPhone/index.vue'),
  },
]
